import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import SettingRemoveModal from './SettingRemoveModal'

interface IRemoveAccommodationsModalProps extends RouteComponentProps {
  setting: { label: string; id: string }
  id: string
  removeVehicleAccomodation: (id: string) => Promise<any>
}

export default class RemoveAccommodationsModal extends React.Component<IRemoveAccommodationsModalProps> {
  public render() {
    return (
      <SettingRemoveModal
        setting={this.props.setting ? this.props.setting : { label: '', id: '' }}
        settingType='Accommodations'
        onRemove={this.onRemove}
        onClose={this.onClose}
      />
    )
  }

  private onRemove = () => {
    this.props.removeVehicleAccomodation(this.props.id).then(() => {
      setTimeout(() => {
        this.onClose()
      }, 1000)
    })
  }

  private onClose = () => {
    this.props.history.push('/global-settings/accommodations')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/RemoveAccommodationsModal.tsx